const SecurityCenter = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.7723 3.72064L8.17877 1.04047C8.12375 1.01383 8.06341 1 8.00229 1C7.94116 1 7.88082 1.01383 7.8258 1.04047L2.23135 3.72064C2.16235 3.75376 2.10407 3.80563 2.06315 3.87031C2.02224 3.93499 2.00036 4.00988 2 4.08641V9.14959C2 13.3779 7.61731 15.5661 7.85232 15.6575C7.94591 15.6935 8.04952 15.6935 8.14311 15.6575C8.38177 15.5661 14 13.3779 14 9.14959V4.08824C13.9996 4.01171 13.9778 3.93682 13.9368 3.87214C13.8959 3.80746 13.8376 3.75559 13.7687 3.72247"
        fill="#0A74FF"
      />
      <path
        d="M6.57588 7.37376L9.75717 10.4069H10.7704V5.38672H9.42798V8.42444L6.24669 5.38672H5.23442V10.406H6.57588V7.37376Z"
        fill="white"
      />
    </svg>
  );
};

export default SecurityCenter;
